import { useTranslation } from '../../../i18n/TranslationContext';

export default function BrandCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-primary-50/30">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4 leading-tight">
          {t('brands.cta.title_line1')}
          <br />
          {t('brands.cta.title_line2')}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10 max-w-xl mx-auto">
          {t('brands.cta.desc')}
        </p>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = '/#contact';
          }}
          className="px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
        >
          {t('brands.cta.button')}
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </section>
  );
}